module.exports = __webpack_public_path__ + "static/media/math_submission.ef91c53b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/math_submission.gif
// module id = 1141
// module chunks = 0